import { render } from "./HomePage.vue?vue&type=template&id=a70199e6&scoped=true&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=a70199e6&scoped=true&lang=scss"

import exportComponent from "/home/apps/bugaplus/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70199e6"]])

export default __exports__